var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},_vm._l((_vm.blok.content),function(blokChild){return _c('component',_vm._b({key:blokChild._uid},'component',_vm.generateComponentItemAttributes(blokChild),false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }